import axios from 'axios'
const endpoint = process.env.VUE_APP_BASE_API + '/api/master/incentiveTiers'

export default {
  async getAll(id) {
    return await axios
      .get(`${endpoint}/list/${id}`)
      .then(response => {
        return response.data.data
      }).catch(error => {
        throw error.response.data
      });
  },
}



// WEBPACK FOOTER //
// ./src/services/master/incentive/incentiveTierService.js